import { Empty, FlexGroup, FlexItem, Loading, ViewLayout } from '@lithos';
import { useGetFcos } from '../../../api/fcos';
import { WorkspaceFCOContainer } from '../../../core/types/fcoTypes';
import { useUserSettings } from '../../context/UserSettingsContext';
import { TECTON_DOCUMENTATION_LINKS } from '../application-links';
import DataSourcesList from './DataSourcesList';

export const DataSourcesContainer = () => {
  const { workspace, workspaceDetails } = useUserSettings();

  const { data, isLoading, isError } = useGetFcos<WorkspaceFCOContainer>(workspace as string, {
    select: (data: WorkspaceFCOContainer) => {
      return {
        dataSources: data.dataSources,
        idToFcoMap: data.idToFcoMap,
      };
    },
  });

  const headerProps = {
    breadcrumbs: {
      root: { label: workspaceDetails?.name ?? '', url: `/repo/${workspaceDetails?.name ?? ''}` },
      items: [{ label: 'Sources' }],
    },
    title: 'Sources',
    subtitle: 'Data Sources define how Tecton connects to batch and stream data.',
    learnMoreLink: TECTON_DOCUMENTATION_LINKS.DATA_SOURCES,
  };

  if (isLoading) {
    return (
      <ViewLayout
        header={headerProps}
        content={
          <FlexGroup direction="column" alignItems="center">
            <FlexItem>
              <Loading />
            </FlexItem>
          </FlexGroup>
        }
      />
    );
  }

  if (isError) {
    return (
      <ViewLayout
        header={headerProps}
        content={
          <Empty
            placement={'full-page'}
            actions={undefined}
            useCase={'errorUnknown'}
            title={<>Error Loading Data Sources</>}
            description={<>There was an error loading Data Sources for this workspace. Please try again.</>}
          />
        }
      />
    );
  }

  return (
    <ViewLayout
      header={headerProps}
      content={
        <DataSourcesList
          items={data?.dataSources ?? []}
          idToFcoMap={data?.idToFcoMap ?? {}}
          workspace={workspace ?? ''}
        />
      }
    />
  );
};

export default DataSourcesContainer;
